module.exports = __webpack_public_path__ + "altaloaders.3d7985d9.png";